// src/app/services/contracts.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ContractForGrid } from '../components/contracts/contracts.component';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { UtilsService } from './utils.service';
import { AuthService } from './auth.service';
import { ContratoLocacionDTO } from '../models/location-contract';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractsService {
  private apiUrl = `${environment.apiUrl}/contrato/locacion`;
  // private mockContracts: ContractForGrid[] = [
  //   { id: 1, inquilino: 'Juan Pérez', propiedadDireccion: 'Av. Siempre Viva 742', agenteNombre: 'Carlos', agenteApellido: 'Gómez', estado: 'ACTIVO' },
  //   { id: 2, inquilino: 'María López', propiedadDireccion: 'Calle Falsa 123', agenteNombre: 'Lucía', agenteApellido: 'Martínez', estado: 'BORRADOR' },
  //   { id: 3, inquilino: 'Pedro Fernández', propiedadDireccion: 'San Martín 456', agenteNombre: 'Roberto', agenteApellido: 'Sánchez', estado: 'FINALIZADO' },
  //   { id: 4, inquilino: 'Juan Pérez', propiedadDireccion: 'Av. Siempre Viva 742', agenteNombre: 'Carlos', agenteApellido: 'Gómez', estado: 'ACTIVO' },
  //   { id: 5, inquilino: 'María López', propiedadDireccion: 'Calle Falsa 123', agenteNombre: 'Lucía', agenteApellido: 'Martínez', estado: 'BORRADOR' },
  //   { id: 6, inquilino: 'Pedro Fernández', propiedadDireccion: 'San Martín 456', agenteNombre: 'Roberto', agenteApellido: 'Sánchez', estado: 'FINALIZADO' },
  //   { id: 7, inquilino: 'Juan Pérez', propiedadDireccion: 'Av. Siempre Viva 742', agenteNombre: 'Carlos', agenteApellido: 'Gómez', estado: 'ACTIVO' },
  //   { id: 8, inquilino: 'María López', propiedadDireccion: 'Calle Falsa 123', agenteNombre: 'Lucía', agenteApellido: 'Martínez', estado: 'BORRADOR' },
  //   { id: 9, inquilino: 'Pedro Fernández', propiedadDireccion: 'San Martín 456', agenteNombre: 'Roberto', agenteApellido: 'Sánchez', estado: 'FINALIZADO' },
  //   { id: 10, inquilino: 'Juan Pérez', propiedadDireccion: 'Av. Siempre Viva 742', agenteNombre: 'Carlos', agenteApellido: 'Gómez', estado: 'ACTIVO' },
  //   { id: 11, inquilino: 'María López', propiedadDireccion: 'Calle Falsa 123', agenteNombre: 'Lucía', agenteApellido: 'Martínez', estado: 'BORRADOR' },
  //   { id: 12, inquilino: 'Pedro Fernández', propiedadDireccion: 'San Martín 456', agenteNombre: 'Roberto', agenteApellido: 'Sánchez', estado: 'FINALIZADO' },
  // ];

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService
  ) { }

  // getContracts(
  //   page: number,
  //   size: number,
  //   filters: any = {}
  // ): Observable<HttpResponse<ContractForGrid[]>> {

  //   // 1) Clonar dataset
  //   let data = [...this.mockContracts];

  //   // 2) FILTROS ESPECÍFICOS
  //   // id (NUMBER): igualdad exacta
  //   if (filters?.id !== undefined && filters?.id !== null && filters.id !== '') {
  //     const idNumber = Number(filters.id);
  //     if (!Number.isNaN(idNumber)) {
  //       data = data.filter(c => c.id === idNumber);
  //     }
  //   }

  //   // inquilino (STRING): contains case-insensitive
  //   if (filters?.inquilino && String(filters.inquilino).trim() !== '') {
  //     const q = String(filters.inquilino).toLowerCase().trim();
  //     data = data.filter(c => c.inquilino.toLowerCase().includes(q));
  //   }

  //   // estado (ENUM): igualdad exacta
  //   if (filters?.estado && String(filters.estado).trim() !== '') {
  //     const estado = String(filters.estado).toUpperCase().trim();
  //     data = data.filter(c => c.estado === estado);
  //   }


  //   // 4) PAGINACIÓN (0-based como tu MatPaginator)
  //   const total = data.length;
  //   const start = page * size;
  //   const end = start + size;
  //   const paged = data.slice(start, end);

  //   // 5) Headers simulados (igual que backend real)
  //   const headers = new HttpHeaders({
  //     'pagination-total-count': String(total),
  //     'page-number': String(page),
  //     'page-size': String(size)
  //   });

  //   return of(new HttpResponse<ContractForGrid[]>({
  //     body: paged,
  //     headers,
  //     status: 200,
  //     statusText: 'OK',
  //     url: 'mock://contracts'
  //   }));
  // }


  getContratos(
    page: number = 0,
    size: number = 10,
    filters: any = {}
  ): Observable<HttpResponse<ContratoLocacionDTO[]>> {
    const url = `${this.apiUrl}/consultas`;

    const params: any = { page: String(page), size: String(size) };
    const serialized = JSON.parse(JSON.stringify(filters));
    Object.entries(serialized).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
    });

    return this.http.get<ContratoLocacionDTO[]>(url, { observe: 'response', params });
  }
  
  getContractById(contractId: number): Observable<ContratoLocacionDTO> {
    const url = `${this.apiUrl}/${contractId}`;
    return this.http.get<ContratoLocacionDTO>(url);
  }
  
  generatePreviewFromContract(contrato: ContratoLocacionDTO): Observable<Blob> {
    const url = `${this.apiUrl}/vista-previa`;
    return this.http.post(url, contrato, {
      responseType: 'blob'
    });
  }


  deleteContract(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
